import { render, staticRenderFns } from "./tax-edit-modal.vue?vue&type=template&id=413f7835&scoped=true&"
import script from "./tax-edit-modal.vue?vue&type=script&lang=js&"
export * from "./tax-edit-modal.vue?vue&type=script&lang=js&"
import style0 from "./tax-edit-modal.vue?vue&type=style&index=0&id=413f7835&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413f7835",
  null
  
)

export default component.exports